import React, { Fragment } from 'react'
import { connect, Provider } from 'react-redux'
import styles from './NotificationsList.scss'
import * as notificationsActions from 'lib/api/notifications'
import { Notification } from './Notification'
import { initStore } from '../redux/initStore'
import { Icon } from 'common/Icon'
import { CircleSpinner } from 'common/spinners'
import { ScrollTrigger } from 'common/ScrollTrigger'
import { FormattedMessage as T } from 'react-intl'

const store = initStore()

// By saving the interval here, we can look for it and only set up 1 periodic refresh sitewide, similar to the store
var intervalID = -1

class NotificationsList extends React.PureComponent {
  componentDidMount = () => {
    if (intervalID === -1) {
      intervalID = setInterval(this.props.loadNotifications, 300000) // 5 minutes
      this.clearInterval = true
    }
    this.markVisibleNotificationsAsSeen()
  }

  componentWillUnmount = () => {
    if (this.clearInterval) {
      clearInterval(intervalID)
    }
  }

  loadNextPage = () => {
    const { nextPage, loadNotifications } = this.props

    if (!nextPage || nextPage === 0) { return } // we handle this case in componentDidMount

    if (nextPage !== -1) {
      loadNotifications(nextPage)
    }
  }

  loadOnScroll = () => {
    this.setState({ loadOnScroll: true })
    this.loadNextPage()
  }

  markVisibleNotificationsAsSeen () {
    const { notifications, markNotificationsSeen } = this.props
    if (notifications) {
      const ids = notifications
        .filter(n => n.readStatus === 'unseen')
        .map(n => n.id)
        .toArray()

      if (ids.length > 0) {
        markNotificationsSeen(ids)
      }
    }
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.notifications !== this.props.notifications) {
      this.markVisibleNotificationsAsSeen()
    }
  }

  render () {
    const { notifications, loading, ctaClicked, actionsTaken, nextPage } = this.props

    const showSpinner = loading && (notifications && notifications.size === 0)
    const showEmpty = !showSpinner && (!notifications || notifications.size === 0)
    const showList = !!notifications
    const showScrollTrigger = !showEmpty && !loading && (nextPage > 0)

    const spinner = <div className={styles.circleSpinner}><CircleSpinner size={25} centered /></div>
    // todo implement correct arrow-positioning for Popovers
    return (
      <Fragment>
        {(showEmpty && <div className={styles.emptyState}>
          <div className={styles.emptyIcon}><Icon i='md-moon' /></div>
          <div><T id='notificationsList.none' defaultMessage="You don't have any notifications right now" /></div>
        </div>)}
        {showSpinner && spinner}
        {showList && notifications.map(n =>
          <Notification key={n.id}
            n={n}
            actionTaken={actionsTaken.get(n.id)}
            ctaClicked={ctaClicked} />
        )}
        {showScrollTrigger && <ScrollTrigger key={nextPage} paddingFactor={0.5} onScrollIntoView={this.loadNextPage}>{spinner}</ScrollTrigger>}
      </Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { notifications } = state

  const notificationsMap = notifications.get('notifications')
  const orderedNotifications = notificationsMap.toList().sortBy(n => n.updatedAt).reverse()

  return {
    notifications: orderedNotifications,
    loading: notifications.get('loading'),
    currentUser: state.currentUser,
    actionsTaken: notifications.get('actionsTaken'),
    nextPage: notifications.get('nextPage')
  }
}

const mapDispatchToProps = {
  loadNotifications: notificationsActions.loadNotifications,
  markNotificationsSeen: notificationsActions.markNotificationsSeen,
  ctaClicked: notificationsActions.ctaClicked
}

const NotificationsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(NotificationsList)

export const NotificationsApp = () => {
  return <Provider store={store}>
    <NotificationsContainer />
  </Provider>
}
